import reducer from './favorites';
import { actionCreators, FavoritesActionType } from './favorites.actionCreators';
import * as actionTypes from './favorites.actionTypes';

export * from './favorites'; // expose all types
export * from './favorites.selectors';
export type ActionType = FavoritesActionType;
export { actionTypes, actionCreators };
export default reducer;
